import { type CommentProps, Comment as AntdComment } from 'antd';
import { type FC } from 'react';

// antd dropped the Comment component in v5
const Comment: FC<CommentProps> = props => {
  return <AntdComment {...props} />;
};

export default Comment;
